{
  "articlesSection": "articoli",
  "bookmarkTitleLabel": "Segnalibri",
  "communitiesSection": "discussioni della community",
  "devConnectionLabel": "Developer Connection",
  "feedback": "Feedback",
  "fetchFailed": "Fetch non riuscito",
  "help": "Aiuto",
  "helpLoadError": "Qualcosa è andato storto. Riprova.",
  "noBookmarks": "Aggiungi i contenuti della guida ai segnalibri per accedervi qui",
  "noBookmarksTitle": "Nessun segnalibro",
  "noResults": "Nessun risultato trovato",
  "noResultsMessage": "Verifica l’ortografia o prova a cercare un altro termine",
  "resourcesCustomerCareLabel": "Assistenza clienti",
  "resourcesStatusLabel": "Stato",
  "solutionsFilterLabel": "Tutte le soluzioni",
  "support": "Supporto",
  "videosSection": "video"
}
